import { Grid } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledErrorWrapper = styled(Grid)`
  padding: ${rem('56px')} 0;
  display: block;
  max-width: ${rem('520px')};
`;

export const StyledErrorLabel = styled.h1`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.cross.red};
  color: ${({ theme }) => theme.colors.main};
  padding: ${rem('12px')} ${rem('16px')};
  border-radius: ${rem('8px')};
  margin: 0;
  text-transform: uppercase;
  font-size: ${rem('24px')};
`;

export const StyledErrorMessage = styled.h1`
  font-size: ${rem('24px')};
  line-height: 1.4;
`;
